"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUser = exports.getGarden = exports.getGardens = void 0;
const connect_thegraph_1 = require("@1hive/connect-thegraph");
const connector_1 = require("./thegraph/connector");
const queries_1 = require("./thegraph/queries");
function getSubgraphClient(config) {
    var _a, _b;
    const subgraphUrl = (_b = (_a = config === null || config === void 0 ? void 0 : config.subgraphUrl) !== null && _a !== void 0 ? _a : (0, connector_1.subgraphUrlFromChainId)(config.network)) !== null && _b !== void 0 ? _b : undefined;
    if (!subgraphUrl) {
        throw new Error('subgraphUrl required to be passed.');
    }
    return new connect_thegraph_1.GraphQLWrapper(subgraphUrl);
}
/**
 * Fetch a list of gardens from a subgraph.
 * @category Main
 * @param config A configuration object.
 * @param params A filters object.
 * @param params.first Number of entities to return.
 * @param params.skip Number of entities to skip.
 * @param params.orderBy Type of filter to order the results.
 * @param params.orderDirection Direction to order the results.
 * @returns A promise that resolves to a group of gardens.
 */
async function getGardens(config, { first = 1000, skip = 0, orderBy = 'createdAt', orderDirection = 'desc' }) {
    const client = getSubgraphClient(config);
    const result = await client.performQuery(queries_1.ORGANIZATIONS, { first, skip, orderBy, orderDirection });
    if (!result.data.organizations) {
        throw new Error('Unable to find gardens.');
    }
    return result.data.organizations;
}
exports.getGardens = getGardens;
/**
 * Fetch a garden from a subgraph.
 * @category Main
 * @param config A configuration object.
 * @param id The garden's id
 * @returns A promise that resolvles to a garden.
 */
async function getGarden(config, id) {
    const client = getSubgraphClient(config);
    const result = await client.performQuery(queries_1.ORGANIZATION, { id });
    if (!result.data.organization) {
        throw new Error(' Unable to find garden.');
    }
    return result.data.organization;
}
exports.getGarden = getGarden;
/**
 * The default way to connect a garden and start fetching data from the subgraph.
 * @category Main
 * @param config A configuration object.
 * @param params A filters object.
 * @param params.id The identifier of a user.
 * @returns A promise that resolves to a group of users.
 */
async function getUser(config, { id }) {
    const client = getSubgraphClient(config);
    const result = await client.performQuery(queries_1.USER, { id });
    if (!result.data.user) {
        throw new Error('Unable to find user.');
    }
    return result.data.user;
}
exports.getUser = getUser;
